export default __webpack_public_path__ + "static/media/cactus.b04aea9a.png";